/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string, func, oneOfType } from 'prop-types';
import { makeStyles } from '@material-ui/core';
import ResponsiveImage from '../../GraphqlComponents/GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';

const useStyles = makeStyles((theme) => ({
    colorSvg: {
        '& > *': {
            fill: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        },
        height: '35px',
        width: '35px',
    },
}));

const ResponsiveImageOrSvg = ({ dynamicIcon, responsiveImageClassName, svgClassName }) => {
    const classes = useStyles();
    if (dynamicIcon) {
        return (typeof dynamicIcon === 'string' && dynamicIcon.includes('https') ? (
            <ResponsiveImage
                alt=""
                className={responsiveImageClassName}
                path={dynamicIcon}
                params={{ desktop: 'quality=100', mobile: 'quality=100' }}
            />
        ) : (
            <div className={`${classes.colorSvg} ${svgClassName}`}>
                {dynamicIcon()}
            </div>
        ));
    }

    return null;
};

ResponsiveImageOrSvg.defaultProps = {
    responsiveImageClassName: '',
    svgClassName: '',
};

ResponsiveImageOrSvg.propTypes = {
    dynamicIcon: oneOfType([string, func]).isRequired,
    responsiveImageClassName: string,
    svgClassName: string,
};

export default ResponsiveImageOrSvg;
